module.exports = __webpack_public_path__ + "img/3.b448f7a4.jpg";